module.exports = __webpack_public_path__ + "img/2012-12-14 19.18.58.1a030efa.jpg";